<template>
  <div class="container mx-auto">
    <div class="flex justify-center">
      <button @click="isOpen = true" type="button">
        <img src="@/assets/logo.png" alt="" class="w-24" />
      </button>

      <div
        v-show="isOpen"
        class="fixed inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50"
      >
        <div class="max-w-2xl p-6 mx-4 bg-white rounded-md shadow-xl">
          <div class="flex items-center justify-between">
            <h3 class="text-2xl p-2">Olá, contate-me!</h3>
            <svg-icon
              @click="isOpen = false"
              type="mdi"
              class="ml-8 w-8 h-8 text-[#050a30] cursor-pointer"
              :path="path"
            >
            </svg-icon>
          </div>
          <div
            v-for="contato in contatos"
            :key="contato.id"
            class="flex items-center"
          >
            <a :href="contato.link">
              <svg-icon type="mdi" class="m-2" :path="contato.icon"></svg-icon>
            </a>
            <p class="text-lg p-2">{{ contato.titulo }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiCloseBoxOutline, mdiEmail, mdiGithub, mdiLinkedin } from "@mdi/js";
import { ref } from "vue";
export default {
  setup() {
    let isOpen = ref(false);
    return { isOpen };
  },
  components: {
    SvgIcon,
  },
  data() {
    return {
      path: mdiCloseBoxOutline,
      contatos: [
        {
          id: 1,
          titulo: "LinkedIn",
          icon: mdiLinkedin,
          link: "https://www.linkedin.com/in/gustavokubiack/",
        },
        {
          id: 2,
          titulo: "E-mail",
          icon: mdiEmail,
          link: "mailto:guukubiack@gmail.com",
        },
        {
          id: 3,
          titulo: "GitHub",
          icon: mdiGithub,
          link: "https://github.com/gustavokubiack/",
        },
      ],
    };
  },
};
</script>
